module.exports = __webpack_public_path__ + "static/img/renshou.600e0b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/renshou.png
// module id = roMf
// module chunks = 1